// extracted by mini-css-extract-plugin
export default {"colourGrey500":"#969696","colourGrey400":"#bebebe","colourGrey300":"#dcdcdc","colourGrey100":"#f3f3f3","colourGreen400":"#32c864","colourWhite":"#fff"};